import { createUseStyles } from 'react-jss'

import { backgroundGrey, black, lightGrey } from '../../../styles/const/colors'
import { fontWeightRegular } from '../../../styles/typography'
import { defaultBorderRadius } from '../../../styles/const/common'
import { phonesDown } from '../../../styles/const/breakpoints'

export default createUseStyles({
  tabsContainer: {
    display: 'flex',
    alignItems: 'center',
    flexShrink: 1,
    padding: '4px 6px',

    fontSize: 14,
    fontWeight: fontWeightRegular,
    color: black,
    background: backgroundGrey,
    border: `2px solid ${lightGrey}`,
    borderRadius: defaultBorderRadius
  },
  [`@media screen and (${phonesDown})`]: {
    tabsContainer: {
      fontSize: 12,
      height: 34
    }
  }
})
